






























































































import FeedbackComponent from '@/components/base/FeedbackComponent'
import {StoreNamespace} from "@/globals/StoreNamespaceGlobal";
import {GridColumn} from '@payroll/grid-widget/src/models/GridColumn'
import Component from 'vue-class-component'
import {Prop} from 'vue-property-decorator'
import {Action} from "vuex-class";

@Component({})
export default class CustomerServiceHistoryGrid extends FeedbackComponent {

  @Prop(Number) crmId!: number;

  @Action('getCrmHistory', StoreNamespace.CUSTOMER_SERVICE) getCrmHistory: any
  @Action('getConfigCRMDetails', StoreNamespace.CUSTOMER_SERVICE) getConfigCRMDetails: any;

  private columns: GridColumn[] = [];
  private companyLevelCrm: any = {}
  private historyRowMap = new Map<number, any>();


  mounted() {
    this.getConfigCRMDetails({
      requestorCallback: this
    })

    this.initColumns();
    this.getGridData({});
  }

  initColumns(): void {
    this.columns.push({property: 'dateCreated', header: 'CustomerServiceHistoryGrid.dateCreated'} as GridColumn)
    this.columns.push({property: 'status', header: 'CustomerServiceHistoryGrid.referralStatus'} as GridColumn)
    this.columns.push({property: 'priority', header: 'CustomerServiceHistoryGrid.priority'} as GridColumn)
    this.columns.push({property: 'department', header: 'CustomerServiceHistoryGrid.department'} as GridColumn)
    this.columns.push({property: 'arrivalSubject', header: 'CustomerServiceHistoryGrid.arrivalSubject'} as GridColumn)
    this.columns.push({property: 'userCreated', header: 'CustomerServiceHistoryGrid.userCreated'} as GridColumn)
    this.columns.push({property: 'userForRouting', header: 'CustomerServiceHistoryGrid.userForRouting'} as GridColumn)
    this.columns.push({property: 'addAttachment', header: 'CustomerServiceHistoryGrid.addAttachment'} as GridColumn)
    this.columns.push({property: 'fullKitDate', header: 'CustomerServiceHistoryGrid.fullKitDate'} as GridColumn)
  }


  onSuccess(data?: any, requestName?: string, message?: string, success?: boolean): void {
    switch (requestName) {
      case 'crmHistory':
        const objectData = {
          hasMore: false,
          resultCount: data.length,
          results: data
        }
        this.$emit('successResults', objectData)
        break;

      case 'crmConfigurationManagement/getConfigCRMDetails':
        this.companyLevelCrm = data.companyLevelCrm
        break;
    }
  }

  private getGridData(searchObject: any) {
    this.getCrmHistory({
      requestorCallback: this,
      pathVariable: this.crmId,
    });
  }

  private currentItem: any = {}
  private lastCurrentItem: any = {}

  private handleInnerLoad(item: any) {
    this.currentItem = item

    if (this.lastCurrentItem && this.lastCurrentItem.contactHistoryId !== this.currentItem.contactHistoryId) {
      this.lastCurrentItem._showDetails = false
      this.lastCurrentItem = this.currentItem
    } else {
      this.lastCurrentItem = this.currentItem
    }
  }

  get receivedEmailNotification(): string {

    if (!this.currentItem) {
      return "לא"
    }

    const str: string = this.currentItem.notificationEmailAddress

    if (!str) {
      return "לא"
    }

    return "כן"
  }

  get receivedSmsNotification(): string {

    if (!this.currentItem) {
      return "לא"
    }

    const str: string = this.currentItem.notificationPhoneNumber

    if (!str) {
      return "לא"
    }

    return "כן"
  }
}


